import React from 'react';
import {ThumbnailImage, ImageResizeOptions} from '@wix/wix-ui-tpa/cssVars';
import {Document, GiftSmall, Download} from '@wix/wix-ui-icons-common/on-stage';
import {ProductType} from '../../../../../constants';
import {Media} from '../../../../../../../types/app.types';
import s from './Thumbnail.scss';

export const ThumbnailDataHook = Object.freeze({
  Wrapper: 'typ-product-thumbnail-wrapper',
  Media: 'typ-product-thumbnail-media',
  DefaultImage: 'typ-default-image',
  Badge: 'typ-product-badge',
});

const THUMBNAIL_SIZE = 100;
const DEFAULT_ICON_SIZE = '50';

type ThumbnailProps = {
  name: string;
  media?: Media | null;
  productType: string;
};

/**
 * Single-layer line-item thumbnail backed by wix-ui-tpa, mirroring the Cart/Checkout approach.
 * Unlike the legacy common-components `ProductImage`, it paints no `background-image` placeholder
 * layer, so transparent PNGs render once with no overlap (ECP-11051). Gated behind typThumbnailWixUiTpa.
 */
export function Thumbnail({name, media, productType}: ThumbnailProps) {
  const isDigital = productType === ProductType.Digital;

  if (!media?.url) {
    return (
      <div
        data-hook={ThumbnailDataHook.DefaultImage}
        className={s.defaultImage}
        style={{width: THUMBNAIL_SIZE, height: THUMBNAIL_SIZE}}>
        {isDigital ? <Document size={DEFAULT_ICON_SIZE} /> : <GiftSmall size={DEFAULT_ICON_SIZE} />}
      </div>
    );
  }

  return (
    <div className={s.productImage} data-hook={ThumbnailDataHook.Wrapper}>
      <ThumbnailImage
        data-hook={ThumbnailDataHook.Media}
        src={media.url}
        width={THUMBNAIL_SIZE}
        height={THUMBNAIL_SIZE}
        alt={media.altText || /* istanbul ignore next */ name}
        resize={ImageResizeOptions.contain}
        aria-hidden={false}
      />
      {isDigital && (
        <div className={s.productBadge} data-hook={ThumbnailDataHook.Badge}>
          <Download />
        </div>
      )}
    </div>
  );
}

Thumbnail.displayName = 'ProductLineItem.Image';
